import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { productDisplayName } from '@kservice';
import { MockComponent } from '@kutil/test';

@Component({
  selector: 'kui-page-welcome',
  standalone: true,
  imports: [RouterLink, TranslocoDirective],
  templateUrl: './page-welcome.component.html',
  styleUrl: './page-welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageWelcomeComponent {
  page = input<string>(''); // NOTE: Translate before passing in
  dialogueLogicKey = input<string>('');

  protected readonly productDisplayName = productDisplayName;
}

export const MockPageWelcomeComponent = MockComponent({
  selector: 'kui-page-welcome',
  standalone: true,
  inputs: ['page'],
});
